import FieldCost from "./cost"
import FieldConfig from "../../../proto/field-config"

export default class FieldCostInternal extends FieldCost {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel          = "Labor cost"
        this.typeDescription    = "Labor cost field"

        this.label              = _.get(config, 'label', this.typeLabel)

        /*switch (this.entityType) {
            case EntityType.PROJECT:
                this.variableName       = '{PROJECT-LABOR-COST}'
                break
        }*/
    }
}
